var map = {
	"./studio 1 main area seating waiting decor.1280x720.webp": 74,
	"./studio 2 main area seating waiting art wide shot.1280x793.webp": 75,
	"./studio 3 side shot ambience art decoration scene vibe.1280x1707.webp": 76,
	"./studio 4 station clean accessories organised work of arts.1280x960.webp": 77,
	"./studio 5 art style vibe gold black face.1280x1707.webp": 78,
	"./studio 6 side shot main area waiting art floor ceiling studio vibes.1280x720.webp": 79,
	"./studio 7 rites of passge compendium tattoo gold.864x1184.webp": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;